"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTP_HEADER_CLIENT_DEVICE = exports.HTTP_HEADER_CLIENT_PLATFORM_VERSION = exports.HTTP_HEADER_CLIENT_PLATFORM = exports.HTTP_HEADER_CLIENT = void 0;
exports.HTTP_HEADER_CLIENT = "x-daytrip-client";
exports.HTTP_HEADER_CLIENT_PLATFORM = "x-daytrip-client-platform";
exports.HTTP_HEADER_CLIENT_PLATFORM_VERSION = "x-daytrip-client-platform-version";
exports.HTTP_HEADER_CLIENT_DEVICE = "x-daytrip-client-device";
//# sourceMappingURL=httpHeaders.js.map